import { receiptConstants } from '../constants';
import { saveParams, deleteParams, createParams } from './base.reducers';

const name = 'receipts';

const initialState = {
	saveLoading: 0,
	saveSuccess: false,
	deleteLoading: 0,
	allLoading: 0,

	receipts: [],
	receiptsById: {}
};

export default (state = initialState, payload) => {
	const { type, data } = payload;
	switch (type) {
		// Save and edit receipts
		case receiptConstants.SAVING_RECEIPT_REQUEST:
			return {
				...state,
				saveSuccess: false,
				saveLoading: state.saveLoading + 1,
			};
		case receiptConstants.SAVING_RECEIPT_SUCCESS:
			const { form } = data;
			return {
				...saveParams({ name, state, form }),
				saveLoading: state.saveLoading - 1,
				saveSuccess: true
			};
		case receiptConstants.SAVING_RECEIPT_FAILURE:	
			return {
				...state,
				saveLoading: state.saveLoading - 1,
			};
		// Delete receipt
		case receiptConstants.DELETE_RECEIPT_REQUEST:
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		case receiptConstants.DELETE_RECEIPT_SUCCESS:
			const id = data;
			return {
				...deleteParams({ name, state, id }),
				deleteLoading: state.deleteLoading - 1
			};
		case receiptConstants.DELETE_RECEIPT_FAILURE:	
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		// Load receipts
		case receiptConstants.LOAD_RECEIPTS_REQUEST:
			return {
				...state,
				allLoading: state.allLoading + 1,
			};
		case receiptConstants.LOAD_RECEIPTS_SUCCESS:
			return {
				...createParams({ name, state, data: data.data }),
				allLoading: state.allLoading - 1
			};
		case receiptConstants.LOAD_RECEIPTS_FAILURE:	
			return {
				...state,
				allLoading: state.allLoading - 1,
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/redux/reducers/receipt.reducers.js